export async function extractResponseErrorMessage(response: Response, fallbackMessage: string): Promise<string> {
  try {
    const data = await response.json()
    return data?.error?.message || fallbackMessage
  } catch {
    return fallbackMessage
  }
}
